/**
 * Defines the methods and variables available to components.
 */
export default abstract class AbstractComponent {
  /**
   * The different breakpoints, in pixels.
   */
  public static readonly BREAKPOINT_SM = 576;
  public static readonly BREAKPOINT_MD = 768;
  public static readonly BREAKPOINT_LG = 992;
  public static readonly BREAKPOINT_XL = 1367;

  /**
   * Initializes the component.
   */
  public abstract initialize(): void;

  /**
   * Called when the window is resized.
   *
   * @param lastWindowSize The last stable window size
   */
  public onWindowResize(lastWindowSize: { width: number, height: number }): void {}
}
